module.exports = __webpack_public_path__ + "static/media/epark-plus.dae7cb4a.svg";